







import Vue from 'vue'

export default Vue.extend({
  name: "ButtonWidget",
  props: {
    uri: String,
    listeners: Array,
    isSmall: Boolean,
  }
})
